import { useSensorTransport } from '../transports/SensorTransportProvider';
import { SensorFilters } from '../types/sensors';

export function useAlarmedBoxes(filters: SensorFilters) {
  return useSensorTransport().useAlarmedBoxes(filters);
}
